/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { Navigate } from "react-router-dom";

const performDispositionsRequest = (setIsLoading, setCustomerData) => {
  const dispositionsFromLocalStorage = JSON.parse(
    localStorage.getItem("dispositions")
  );
  if (dispositionsFromLocalStorage) {
    setCustomerData((prevState) => ({
      userDetailsInfo: prevState.userDetailsInfo,
      userOrders: prevState.userOrders,
      userPaymentInfo: prevState.userPaymentInfo,
      userCallNotesInfo: prevState.userCallNotesInfo,
      userEmailNotesInfo: prevState.userEmailNotesInfo,
      userMembershipInfo: prevState.userMembershipInfo,
      userTrackingInfo: prevState.userTrackingInfo,
      userProgramsInfo: prevState.userProgramsInfo,
      userLoginHistoryInfo: prevState.userLoginHistoryInfo,
      dispositions: {
        dispositions: dispositionsFromLocalStorage,
        success: true,
      },
      userEvents: prevState.userEvents,
      userReportHistory: prevState.userReportHistory,
      userCallLog: prevState.userCallLog,
      userLockouts: prevState.userLockouts,
      userReportDownloads: prevState.userReportDownloads
    }));
  } else {
    (async () => {
      const res = await fetch(`/api/customer/dispositions`, {
        method: "GET",
        credentials: "include",
      });
      if (res.status !== 200)
        return (
          <Navigate
            to={{
              pathname: "/",
            }}
          />
        );
      const { success, result } = await res.json();
      localStorage.setItem("dispositions", JSON.stringify(result));
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: { dispositions: result, success },
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
    })();
  }
};

const performUserDetailsRequest = (
  id,
  userId,
  setIsLoading,
  setCustomerData
) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/details?userId=${userId}`, {
      method: "GET",
      credentials: "include",
    });

    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: { ...result, success },
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads,
      }));
      setIsLoading(false);
    }
  })();
};

const performUserOrdersRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/orders`, {
      method: "GET",
      credentials: "include",
    });
    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: { orders: [...result], success },
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserCallNotesRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/call-notes`, {
      method: "GET",
      credentials: "include",
    });

    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: {
          callNotes: [...result],
          success,
        },
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserEmailLogsRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/email-logs`, {
      method: "GET",
      credentials: "include",
    });
    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: {
          emailNotes: [...result?.emailLogResults],
          totalEmailLogs : result?.totalEmailLogs,
          success,
        },
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserMembershipsRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/memberships`, {
      method: "GET",
      credentials: "include",
    });

    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: { membershipInfo: [...result], success },
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserTrackingRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/tracking`, {
      method: "GET",
      credentials: "include",
    });

    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: { ...result, success },
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserProgramsRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/programs`, {
      method: "GET",
      credentials: "include",
    });

    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: { programInfo: result, success },
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserPaymentRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/payment`, {
      method: "GET",
      credentials: "include",
    });

    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: { ...result, success },
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserLoginHistoryRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/login-history`, {
      method: "GET",
      credentials: "include",
    });

    const { result, success } = await res.json();

    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: {
          loginHistoryInfo: [...result?.loginResults],
          totalLogins : result?.totalLogins,
          success,
        },
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserMemberEventsRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/member-events`, {
      method: "GET",
      credentials: "include",
    });
    const { result, success } = await res.json();

    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: {
          events: [...result?.memberEventResults],
          totalMemberEvents : result?.totalMemberEvents,
          success,
        },
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performCustomerLockoutsRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/customer-lockouts`, {
      method: "GET",
      credentials: "include",
    });
    const { result, success } = await res.json();

    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userReportDownloads: prevState.userReportDownloads,
        userLockouts: {
          lockouts: [...result],
          success,
        },
      }));
      setIsLoading(false);
    }
  })();
};

const performUserReportDownloadsRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/report-downloads`, {
      method: "GET",
      credentials: "include",
    });
    const { result, success } = await res.json();

    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: {
          reportDownloads: {...result},
          success,
        },
      }));
      setIsLoading(false);
    }
  })();
};

const performUserReportHistoryRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/report-history`, {
      method: "GET",
      credentials: "include",
    });
    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: { history: { ...result }, success },
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

const performUserCallLogRequest = (id, setIsLoading, setCustomerData) => {
  (async () => {
    setIsLoading(true);
    const res = await fetch(`/api/customer/${id}/call-log`, {
      method: "GET",
      credentials: "include",
    });
    const { result, success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: { callLog: [...result], success },
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
      setIsLoading(false);
    }
  })();
};

export {
  performUserDetailsRequest,
  performUserCallNotesRequest,
  performUserEmailLogsRequest,
  performUserMembershipsRequest,
  performUserTrackingRequest,
  performUserProgramsRequest,
  performUserPaymentRequest,
  performUserLoginHistoryRequest,
  performDispositionsRequest,
  performUserOrdersRequest,
  performUserMemberEventsRequest,
  performUserReportHistoryRequest,
  performUserCallLogRequest,
  performCustomerLockoutsRequest,
  performUserReportDownloadsRequest
};
